import './Footer.css'

const Footer = () => (
  <footer className="footer">
    <div className="footer__inner">
      <span className="footer__logo">pasindu.se</span>
      <p className="footer__text">
        &copy; {new Date().getFullYear()} Pasindu Perera
      </p>
    </div>
  </footer>
)

export default Footer
